const keyboardDatePickerActionModalFilter = {
  from: 'De',
  to: 'Até'
};

export default keyboardDatePickerActionModalFilter;
